import { render, staticRenderFns } from "./how_to_use_description.vue?vue&type=template&id=42d4ce3b&lang=pug"
var script = {}
import style0 from "./how_to_use_description.vue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports